export * from './normalizer.directive';
export * from './normalizer.factory';
export * from './normalizer.i';

import {TypeNormalizerDirective} from './normalizer.directive';

export const NORMALIZER_DIRECTIVES = [
    TypeNormalizerDirective
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/normalizers/index.ts